import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadUser } from '../../store/userSlice'
// import cookies from 'js-cookie'

const RefreshToken = ({ children }) => {
  const loaded = useSelector((state) => state.user.loaded)
  const dispatch = useDispatch()

  useEffect(async () => {
    await dispatch(loadUser())
  }, [])
  return loaded ? <>{children}</> : <></>
}

RefreshToken.propTypes = {
  children: PropTypes.any,
}

export default RefreshToken
